import { useTranslation } from 'react-i18next';
import { Box, IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { TripLegFieldsRow } from './TripLegFieldsRow';

export interface MultiTripLegsSectionProps {
  fields: { id: string }[];
  remove: (index: number) => void;
}

export function MultiTripLegsSection({ fields, remove }: MultiTripLegsSectionProps) {
  const { t } = useTranslation('common');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {fields.map((field, index) => (
        <Box
          key={field.id}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 1,
          }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <TripLegFieldsRow
              index={index}
              tripLabel={t('reservation.leg', { leg: index + 1 })}
            />
          </Box>
          {fields.length > 1 ? (
            <IconButton
              type="button"
              aria-label={`Remove trip ${index + 1}`}
              onClick={() => remove(index)}
              color="error"
              size="small">
              <DeleteOutlineIcon />
            </IconButton>
          ) : null}
        </Box>
      ))}
    </Box>
  );
}
